<template>
  <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-6 flex flex-col">
        <ShowInOpenseaLink :tokenId="tokenId" />

    <div class="iframe1by1 shadow-lg hover:grow hover:shadow-lg">
      <iframe
        v-if="contentUri != ''"
        scrolling="no"
        sandbox="allow-same-origin allow-scripts"
        :src="httpUri(contentUri)"
      ></iframe>
    </div>

    <div class="pt-3">
      <a
        class="text-gray-800 block underline hover:text-gray-900"
        :href="httpUri(contentUri)"
        target="_blank"
        >{{ metadata.name }}</a
      >
      <small>#{{ parseInt(editionNumber) }} of {{ edition }} minted</small>
      
    </div>
  </div>
</template>

<script>
import NftMixins from './mixins/NftMixins.js'

export default {
  name: "OwnerNft",
  mixins:[NftMixins]

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe1by1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.iframe1by1 > iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.hover\:grow {
  transition: all 0.3s;
  transform: scale(1);
}

.hover\:grow:hover {
  transform: scale(1.02);
}
</style>
